import React from "react";
import { Box } from "./style";
import Modal from "./modal";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      currentShow: 0
    };
  }

  bigAdd() {
    let files = this.props.files;
    if (files && files.length < this.props.limit) {
      return (
        <React.Fragment>
          <label htmlFor="file" className="add-file-big">
            <i className="icon mapsa-plus" />
          </label>
        </React.Fragment>
      );
    }
  }

  closeModal() {
    const { group } = this.props;
    if (group) {
      group.handleImageMStatus(false);
    } else {
      this.setState({ modalStatus: false });
    }
  }

  setName = name => {
    let extraPart = "";
    const { group } = this.props;
    if (group) {
      extraPart = `-${group.index}`;
    }
    return `${name}${extraPart}`;
  };

  showModal(selectedImage) {
    const { group } = this.props;
    if (group) {
      group.handleImageMStatus(true);
    } else {
      this.setState({ modalStatus: true });
    }
    this.setState({
      currentShow: selectedImage
    });
  }

  modalView() {
    const { group } = this.props;
    const { modalStatus, currentShow } = this.state;
    let show;
    if (group) {
      show = group.mStatus;
    } else {
      show = modalStatus;
    }
    return (
      <Modal
        groupId={group && group.index}
        show={show}
        files={this.props.files}
        current={currentShow}
        whitOutProject={this.props.whitOutProject}
        close={() => this.closeModal()}
      />
    );
  }

  src(file) {
    if (file.id) {
      return file.path;
    } else {
      return window.URL.createObjectURL(file);
    }
  }

  toggleRefreshButton(index, show) {
    const id = `${this.setName("#refreshButtonId")}-${index}`;
    const refreshButton = document.querySelector(`${id}`);
    if (show) {
      refreshButton.style.display = "flex";
    } else {
      refreshButton.style.display = "none";
    }
  }
  reloadImage(e, index, imageSrc) {
    const id = `${this.setName("#imageId")}-${index}`;
    e.stopPropagation();
    const img = document.querySelector(`${id}`);
    img.src = imageSrc;
    this.toggleRefreshButton(index, false);
  }
  render() {
    const { files } = this.props;
    return (
      <Box>
        <div className="files">
          {files.map((file, i) => (
            <div key={i} className="image-slider-file">
              <img
                className="image-slider-img"
                id={`${this.setName("imageId")}-${i}`}
                src={this.src(file)}
                alt=""
                onClick={e => {
                  e.stopPropagation();
                  this.showModal(i);
                }}
                onError={() => {
                  this.toggleRefreshButton(i, true);
                }}
                onLoad={() => this.toggleRefreshButton(i, false)}
              />
              <div
                className="refresh-button-container"
                id={`${this.setName("refreshButtonId")}-${i}`}
                onClick={e => this.reloadImage(e, i, file.path)}
              >
                <img src="/images/refresh.png" alt="" />
              </div>
            </div>
          ))}
          {this.bigAdd()}
        </div>
        {this.modalView()}
      </Box>
    );
  }
}
export default Index;
